module.exports = __webpack_public_path__ + "img/492.ed7607a4.jpg";